'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import { NewsType } from '@/@types'
import NewsCard from '@/components/NewsCard'

interface ClientNewsCardProps {
  post: NewsType
  index: number
}

const ClientNewsCard: React.FC<ClientNewsCardProps> = ({ post, index }) => {
  const router = useRouter()

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      router.push(`/${post.slug}`)
    }
  }

  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      <NewsCard post={post} index={index} />
    </div>
  )
}

export default ClientNewsCard
